<template>
  <div class="row" v-if="meta">
    <div class="col">
      <div
          class="dataTables_paginate paging_simple_numbers float-end"
      >
        <ul class="pagination pagination-rounded mb-0">
          <!-- pagination -->
          <b-pagination
              v-model="currentPage"
              align="center"
              :total-rows="meta.total"
              :per-page="meta.per_page"
              @input="setPagination"
          ></b-pagination>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    meta: {
      type: Object,
      Default: null
    },
    align: {
      Default: null
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  methods: {
    setPagination(e) {
      this.$emit('input', e)
    }
  }
}
</script>

<style scoped>

</style>